export class GeneralCondition {
    static options() {
        return [
            {
                value: 'tidy',
                text: 'Tidy'
            },
            {
                value: 'poor',
                text: 'Poor due to storm flows'
            },
            {
                value: 'minor',
                text: 'Needs minor works'
            },
            {
                value: 'major',
                text: 'Needs major works'
            },
            {
                value: 'need_engineer',
                text: 'Needs engineer'
            }
        ];
    }
}


// WEBPACK FOOTER //
// ./src/helpers/general-condition-options.js